import type { ReactNode } from 'react';
import { Modal, type ModalProps } from '@mantine/core';

import classes from './Modal.module.css';

interface MercuryModalProps extends ModalProps {
  alternativeBackground?: boolean;
  allowOverflow?: boolean;
  link?: ReactNode;
  linkPosition?: 'title' | 'close';
}

const mergeClassNames = (...classNames: Array<string | undefined>) =>
  classNames.filter(Boolean).join(' ');

const MercuryModal = ({
  children,
  alternativeBackground,
  allowOverflow,
  link,
  linkPosition = 'title',
  classNames,
  withCloseButton = true,
  closeButtonProps,
  overlayProps,
  title,
  ...modalProps
}: MercuryModalProps) => (
  <Modal.Root
    {...modalProps}
    classNames={{
      ...classNames,
      title: mergeClassNames(classes.title, classNames?.title),
      header: mergeClassNames(
        alternativeBackground ? classes.alternativeBg : undefined,
        link ? classes.headerWithLink : undefined,
        classNames?.header
      ),
      content: mergeClassNames(
        alternativeBackground ? classes.alternativeBg : undefined,
        allowOverflow ? classes.allowOverflow : undefined,
        classNames?.content
      ),
      close: mergeClassNames(classes.close, classNames?.close),
    }}
  >
    <Modal.Overlay {...overlayProps} />
    <Modal.Content>
      {(title || withCloseButton) && (
        <Modal.Header>
          {title && (
            <div className={`${link && linkPosition === 'title' ? classes.titleWrapper : ''}`}>
              <Modal.Title component="h1">{title}</Modal.Title>
              {linkPosition === 'title' && link}
            </div>
          )}

          {linkPosition === 'close' ? (
            <div className={classes.closeActions}>
              {link}
              {withCloseButton && <Modal.CloseButton {...closeButtonProps} />}
            </div>
          ) : (
            withCloseButton && <Modal.CloseButton {...closeButtonProps} />
          )}
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
    </Modal.Content>
  </Modal.Root>
);

export default MercuryModal;
